<template>
    <form class="o-loginRegister o-loginRegister--register" @submit.prevent="handleSubmit">
        <div class="o-loginRegister__row">
            <p class="a-title o-loginRegister__title">Zarejestruj się</p>

            <a-button
                class="o-loginRegister__loginRegisterButton o-loginRegister__loginRegisterButton--register"
                type="fullwidth-light"
                @click="$router.push({ name: 'login' })"
            >
                Posiadasz konto? Zaloguj się.
            </a-button>
        </div>
        <div  v-if="trialDays > 0" class="o-loginRegister__row">
            <div class="o-subscriptions__card o-subscriptions__card--register">
                <p class="o-subscriptions__cardMonthsValue">
                {{trialDays}}
                </p>
                <p class="o-subscriptions__cardMonthsText">
                    dni
                </p>
                <hr class="o-subscriptions__divider" />
                <p class="a-text a-text--center o-subscriptions__pricePerMonthValue ">
                    Wypróbuj aplikację na swoim polu. Skorzystaj z okresu testowego!
                </p>
            </div>
        </div>
        <div class="o-loginRegister__row">
            <o-user-add-form
                hide-customer
                hide-devices
                :first_name.sync="first_name"
                :last_name.sync="last_name"
                :email.sync="email"
                :phone.sync="phone"
                :counties.sync="counties"
                :devices_number.sync="devices_number"
                :customer.sync="customer"
                formCustomClass="labels-white"
                ref="registerForm"
            />
            <div class="m-control">
                <a-checkbox :checked.sync="terms" customClass="text-white">
                    Oświadczam, że znam i akceptuję postanowienia
                    <a :href="termsData.file_link" target="_blank">
                        Regulaminu </a
                    >. Wiąże się to z pobraniem regulaminu.
                </a-checkbox>
            </div>
        </div>

        <div class="o-loginRegister__row o-loginRegister__buttonWrapper">
            <a-button
                class="o-loginRegister__button"
                type="fullwidth-light"
                icon="Login"
                :submit="true"
                :is-processing="authStatus === 'pending'"
            >
                Zarejestruj
            </a-button>
        </div>
    </form>
</template>

<script>
import OUserAddForm from '@/components/OUserAddForm'
import ACheckbox from '@/components/global/ACheckbox.vue'

export default {
    name: 'Register',
    metaInfo: {
        title: 'Logowanie'
    },
    components: {
        OUserAddForm,
        ACheckbox
    },
    created() {
        this.$store.dispatch('termsAndConditions/fetchTerms')
        this.$store.dispatch('subscriptions/fetchTrialDays')
    },
    data() {
        return {
            terms: false,
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            counties: [],
            devices_number: 1,
            customer: 'possible_customer'
        }
    },
    computed: {
        termsData() {
            return this.$store.getters['termsAndConditions/terms']
        },
        version() {
            return process.env.PACKAGE_VERSION
        },
        environment() {
            return process.env.VUE_APP_MODE
        },
        authStatus() {
            return this.$store.getters.authStatus
        },
        trialDays() {
            return this.$store.getters['subscriptions/trialDays']
        }
    },
    methods: {
        handleSubmit() {
            if (!this.$refs.registerForm.validateForm()) return
            if (!this.terms) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Zaznacz wymagane zgody'
                })
                return false
            }

            this.$store
                .dispatch('register', {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    phone: this.phone,
                    terms_of_use: this.terms,
                    counties: this.counties.map(item => {
                        return { id: item.id }
                    })
                })
                .then(() => {
                    this.$router.push({ name: 'register-success' })
                })
                .catch(error => {
                    let message = ''

                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.data &&
                        error.response.data.data.errors
                    ) {
                        const errorFields = error.response.data.data.errors
                        Object.entries(errorFields).forEach(field => {
                            const fieldName = field[0]

                            if (fieldName === 'email') {
                                message += 'Pole email:'
                            } else if (fieldName === 'phone') {
                                message += 'Pole telefon:'
                            } else {
                                return
                            }
                            const fieldErrors = Object.values(field[1]).join(
                                ', '
                            )
                            message += ` ${fieldErrors}`
                        })
                    }
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: `Wystąpił błąd. ${message}`
                    })
                })
        }
    }
}
</script>
